import { render } from "./PurchaseOrders.vue?vue&type=template&id=07d97d38&ts=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrders.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__